import React from 'react';
import { FaTripadvisor } from "react-icons/fa";

interface TripAdvisorProps {
  rating: number;
  maxRating?: number;
}

const FullBall = () => <div className="w-4 h-4 bg-tripadvisor rounded-full" />;
const HalfBall = () => (
  <div className="relative w-4 h-4 rounded-full border border-tripadvisor bg-white">
    <div className="absolute inset-0 w-2 bg-tripadvisor  rounded-l-full" />
  </div>
);
const EmptyBall = () => <div className="w-4 h-4 bg-white border-tripadvisor border rounded-full" />;

const TripAdvisor: React.FC<TripAdvisorProps> = ({ rating, maxRating = 5 }) => {
  let balls = [];
  for (let i = 1; i <= maxRating; i++) {
    if (i <= rating) {
      balls.push(<FullBall key={`full-${i}`} />);
    } else if (i - 0.5 === rating) {
      balls.push(<HalfBall key={`half-${i}`} />);
    } else {
      balls.push(<EmptyBall key={`empty-${i}`} />);
    }
  }

  return <div className="flex gap-1">
    <FaTripadvisor />
       <div className="flex items-center space-x-1">{balls}</div>
    </div>;
};

export default TripAdvisor;
